import * as project from '../../package.json'

export const environment = {
  version: project.version,
  name: project.name,
  project: project.project,
  production: false,
  ignorePermissions: false
}
